import PortfolioConfigData from "config/portfolio-config.json";
import React from "react";
import PortfolioTablePie from "../single/components/portfolio-table-pie/PortfolioTablePie";
import styles from "pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss";
import PortfolioCompareTableBar from "../compare/components/PortfolioCompareTableBar";

type SectionChildrenProps = { reportData: any; reportData2?: any };
const DistribuzioneTipologiaStrumentiContainer: React.FC<
  SectionChildrenProps
> = ({ reportData, reportData2 }) => {
  if (!reportData) {
    return <></>;
  }

  return (
    <div className={styles.sectionContainer}>
      {/* ***************** */}
      {/* SINGLE PORTFOLIO */}
      {/* ***************** */}
      {!reportData2 && (
        <>
          <PortfolioTablePie
            dataItem={{
              data: reportData.scomposizione_portafoglio
                .distribuzione_tipologia,
              configData:
                PortfolioConfigData.scomposizione_portafoglio.data
                  .distribuzione_tipologia,
            }}
          />
          {reportData.scomposizione_portafoglio
            .distribuzione_tipologia_strumenti && (
            <div style={{ marginTop: 40, marginBottom: 40 }}>
              <PortfolioTablePie
                dataItem={{
                  data: reportData.scomposizione_portafoglio
                    .distribuzione_tipologia_strumenti,
                  configData:
                    PortfolioConfigData.scomposizione_portafoglio.data
                      .distribuzione_tipologia_strumenti,
                }}
              />
            </div>
          )}
        </>
      )}
      {/* ***************** */}
      {/* COMPARE PORTFOLIO */}
      {/* ***************** */}
      {reportData2 && (
        <div style={{ marginTop: 0 }}>
          <PortfolioCompareTableBar
            dataItem={{
              data: reportData.scomposizione_portafoglio
                .distribuzione_tipologia,
              configData:
                PortfolioConfigData.scomposizione_portafoglio.data
                  .distribuzione_tipologia,
            }}
            dataItem2={{
              data: reportData2.scomposizione_portafoglio
                .distribuzione_tipologia,
              configData:
                PortfolioConfigData.scomposizione_portafoglio.data
                  .distribuzione_tipologia,
            }}
          />
          {reportData.scomposizione_portafoglio
            .distribuzione_tipologia_strumenti && (
            <div style={{ marginTop: 40, marginBottom: 12 }}>
              <PortfolioCompareTableBar
                dataItem={{
                  data: reportData.scomposizione_portafoglio
                    .distribuzione_tipologia_strumenti,
                  configData:
                    PortfolioConfigData.scomposizione_portafoglio.data
                      .distribuzione_tipologia_strumenti,
                }}
                dataItem2={{
                  data: reportData2.scomposizione_portafoglio
                    .distribuzione_tipologia_strumenti,
                  configData:
                    PortfolioConfigData.scomposizione_portafoglio.data
                      .distribuzione_tipologia_strumenti,
                }}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default React.memo(
  DistribuzioneTipologiaStrumentiContainer,
  (prevProps: SectionChildrenProps, nextProps: SectionChildrenProps) => {
    // Custom comparison function
    return prevProps.reportData === nextProps.reportData;
  },
);
